// extracted by mini-css-extract-plugin
export default {"formBodyData":"myCompanyForm_formBodyData__B4RL4","viewLink":"myCompanyForm_viewLink__4bsEK","eyeIcon":"myCompanyForm_eyeIcon__Jt7bi","tybeBg":"myCompanyForm_tybeBg__jJvKZ"};